// extracted by mini-css-extract-plugin
module.exports = {"circleContent":"group_circleContent__uhV1c","circleList":"group_circleList__Ggq9I","circleCardItem":"group_circleCardItem__fQlkk","circleTitle":"group_circleTitle__ynAtT"};